//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import '@esri/calcite-components/dist/components/calcite-action';
import '@esri/calcite-components/dist/components/calcite-action-group';
import {
  CalciteAction,
  CalciteActionGroup,
} from '@esri/calcite-components-react'
import { setWheelZoom } from '@/reducks/setting';

/**
 * 地図ホイール動作設定ボタン
 */
export default function MapWheelSetting({
  slot,
  viewRef,
}) {

  // ホイール動作状態 (ホイールで拡大/縮小)
  const wheelZoom = useSelector((state) => state.setting.wheelZoom) ?? true;

  // 設定ボタン処理
  const dispatch = useDispatch();
  const handleWheelZoom = (enabled) => {
    const view = viewRef.current;
    if (view) {
      console.info('ホイール設定', enabled);
      enableWheelZoom(view, enabled);    // 地図設定更新
      dispatch(setWheelZoom(enabled));   // ストア状態更新
    }
  };

  //
  // 描画
  //
  return (
    <CalciteActionGroup slot={slot}>

      {/* ホイールズーム無効化 */}
      <CalciteAction
        icon="arrow-up-down" scale="s"
        active={!wheelZoom}
        title="マウスホイールによる拡大/縮小を無効にします。"
        onClick={() => handleWheelZoom(false)}
      />

      {/* ホイールズーム有効化 */}
      <CalciteAction
        icon="zoom-out-fixed" scale="s"
        active={wheelZoom}
        title="マウスホイールで地図を拡大/縮小します。"
        onClick={() => handleWheelZoom(true)}
      />
    </CalciteActionGroup>
  );
}

// プロパティ
MapWheelSetting.propTypes = {
  slot:    PropTypes.string.isRequired,    // スロット位置
  viewRef: PropTypes.object.isRequired,    // 地図ビュー参照
};

/**
 * マウスホイール動作モード設定
 */
export function enableWheelZoom(view, enabled) {
  const value = enabled ? 'zoom' : 'none';
  view.navigation.actionMap.mouseWheel = value;
}
